import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Button from "components/library/Button";
import TakeoverPanel from "components/library/TakeoverPanel";
import TakeoverHeader from "components/library/TakeoverHeader";
import TextInput from "components/library/TextInput";
import AsyncDropdown from "components/library/AsyncDropdown";
import Label from "components/library/Label";
import CreateTagAsyncDropdownOption from "settings/components/CreateTagAsyncDropdownOption";
import LinkButton from "components/library/LinkButton";

import {
  createTagAsync,
  getTagTypesListAsyncForTypeahead,
} from "settings/actions/tags";
import { setMessage } from "actions/message";

import styles from "./CreateTag.css";

const TAG_TYPE_INPUT_ID = "tagType";

class CreateTag extends React.Component {
  constructor(props) {
    super(props);

    this.setTagName = this._setTagName.bind(this);
    this.setTagType = this._setTagType.bind(this);
    this.createTag = this._createTag.bind(this);

    this.state = {
      tag: { name: null, tag_type: null },
      errorText: "",
    };
  }

  _setTagName(event) {
    event.preventDefault();
    this.setState({ tag: { ...this.state.tag, name: event.target.value } });
  }

  _setTagType(type) {
    this.setState({ tag: { ...this.state.tag, tag_type: type } });
  }

  _createTag() {
    if (this.state.tag.name) {
      if (this.state.errorText) {
        this.setState({ errorText: "" });
      }

      this.props
        .createTagAsync(this.state.tag)
        .then(() => {
          this.props.history.push("/settings/tags");
          this.props.setMessage({
            message: "Your tag was created",
            type: "success",
          });
        })
        .catch(error => {
          this.props.setMessage({ message: error });
        });
    } else {
      this.setState({ errorText: "Please add a tag name before continuing" });
    }
  }

  render() {
    return (
      <TakeoverPanel>
        <TakeoverHeader className={styles.header}>New tag</TakeoverHeader>
        <p className={styles.info}>
          For instructions on creating a tag, see{" "}
          <a
            className={styles.link}
            href="https://docs.google.com/document/d/1Q3zVXuQO56WtybaYTgXeZqytqaUY3dzQ2pJbxoO8xcE/edit"
            target="_blank"
          >
            the documentation
          </a>
          .
        </p>
        <TextInput
          type="text"
          label="Tag name"
          labelDisplay="visible"
          className={styles.nameInput}
          placeholder="Type a tag name"
          onChange={this.setTagName}
          autoFocus={true}
          error={this.state.errorText}
        />

        <div className={styles.typeInput}>
          <Label htmlFor={TAG_TYPE_INPUT_ID}>Tag type</Label>
          <AsyncDropdown
            className="gtm-tag-type"
            inputId={TAG_TYPE_INPUT_ID}
            value={this.state.tag.tag_type}
            onChange={this.setTagType}
            loadOptions={this.props.getTagTypesListAsyncForTypeahead}
            filterOptions={true}
            labelKey="name"
            valueKey="slug"
            placeholder="Select a tag type"
            backspaceRemoves={false}
            optionComponent={CreateTagAsyncDropdownOption}
            matchPos="start"
          />
        </div>

        <Button type="submit" onClick={this.createTag}>
          Create new tag
        </Button>
        <LinkButton to="/settings/tags" type="cancel">
          Cancel
        </LinkButton>
      </TakeoverPanel>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  getTagTypesListAsyncForTypeahead,
  createTagAsync,
  setMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateTag);

CreateTag.propTypes = {
  getTagTypesListAsyncForTypeahead: PropTypes.func.isRequired,
  createTagAsync: PropTypes.func.isRequired,
  setMessage: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
};
